@if (areMultiselect) {
  <siat-multiselect-field
    [formGroup]="formGroup"
    [controlName]="controlName"
    [id]="id"
    [name]="name"
    [label]="label"
    [placeholder]="placeholder"
    [items]="items()"
  ></siat-multiselect-field>
} @else {
  <siat-select-field
    [formGroup]="formGroup"
    [controlName]="controlName"
    [id]="id"
    [name]="name"
    [label]="label"
    [emptyMessage]="emptyMessage()"
    [placeholder]="placeholder"
    [items]="items()"
  ></siat-select-field>
}
